import { render } from "./list-item.vue?vue&type=template&id=50e3854c&scoped=true"
import script from "./list-item.vue?vue&type=script&lang=js"
export * from "./list-item.vue?vue&type=script&lang=js"

import "./list-item.vue?vue&type=style&index=0&id=50e3854c&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e3854c"],['__file',"src/components/admin-dashboard/list/list-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50e3854c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50e3854c', __exports__)) {
    api.reload('50e3854c', __exports__)
  }
  
  module.hot.accept("./list-item.vue?vue&type=template&id=50e3854c&scoped=true", () => {
    api.rerender('50e3854c', render)
  })

}


export default __exports__